import { t, Instance } from 'mobx-state-tree';

/**
 * Manages the left and right root persons based on the tree anchor from HybridPedigreeStore
 */
export const RootGenerationModel = t
  .model('RootGeneration', {
    leftRootFamilyMemberId: t.maybeNull(t.string),
    rightRootFamilyMemberId: t.maybeNull(t.string)
  })
  .actions((self) => ({
    setLeftRootFamilyMemberId(leftRootFamilyMemberId: string | null) {
      self.leftRootFamilyMemberId = leftRootFamilyMemberId;
    },

    setRightRootFamilyMemberId(rightRootFamilyMemberId: string | null) {
      self.rightRootFamilyMemberId = rightRootFamilyMemberId;
    },

    clear() {
      self.leftRootFamilyMemberId = null;
      self.rightRootFamilyMemberId = null;
    }
  }));

export type RootGenerationType = Instance<typeof RootGenerationModel>;

/**
 * Design Note:
 * RootGenerationModel is a display/view model that stores which two people are shown in the root generation.
 * PersonModel is the source of truth for spouse data (spouseFamilyMemberIds, lastSelectedSpouseFamilyMemberId).
 * When spouse selection changes, PersonModel.selectSpouse() is called, and then HybridPedigreeStore
 * updates RootGeneration based on PersonModel's selectedSpouseFamilyMemberId.
 */
